import { ButtonCSSStyleImpl } from '../../../../toolkit/button/buttoncss';
import { Fonts } from '../../../../../utils/resources/fonts';

export class GroupButtonCSSStyleImpl extends ButtonCSSStyleImpl
{
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '40px', 
        width: '100%', 
        cursor: "pointer",
        outline:'none'

      };
    }
    getButtonStyle():object{
        return{
            width:'100%',
            height: '40px',
            float: 'left', 
            borderRadius: '3px',
            border: "1px solid #D7006D",
            overflow: 'hidden',
            backgroundColor: "#ffffff",
            cursor: "pointer",
            alignContent: 'center',
            alignItems: "center",
            justifyContent: "center",
            outline:'none'

        };
    }

    getButtonText():object
    {
        return{
            color: "#D7006D", 
            fontSize: this.getResources().getFont(Fonts.h6), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/groupbuttoncss.ts